module.exports = __webpack_public_path__ + "components/flag/static/square/ic-133de251a7937c26eca59da87c0d355d.svg";